var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 239.999,
    height: 154,
    viewBox: "0 0 239.999 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 6",
    clipPath: "url(#clip0_0_2734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M102.189 15.8217C102.189 15.8217 77.7938 -2.22568 53.407 0.229585C29.0201 2.68485 4.38065 34.1296 4.38065 34.1296L12.2754 40.1138C12.2754 40.1138 53.1938 6.16643 75.3543 31.2638C97.5149 56.3612 102.189 15.8217 102.189 15.8217Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.2,
    d: "M102.189 15.8217C102.189 15.8217 77.7938 -2.22568 53.407 0.229585C29.0201 2.68485 4.38065 34.1296 4.38065 34.1296L12.2754 40.1138C12.2754 40.1138 53.1938 6.16643 75.3543 31.2638C97.5149 56.3612 102.189 15.8217 102.189 15.8217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M83.7632 13.3034H0V67.4218H83.7632V13.3034Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.15,
    d: "M219.331 128.302C217.788 127.992 216.333 127.344 215.073 126.406C213.812 125.467 212.778 124.262 212.044 122.876V122.798L174.663 52L154.089 66.4862L168.639 111.978C169.022 113.174 169.109 114.445 168.892 115.682C168.675 116.918 168.16 118.084 167.391 119.08C166.622 120.076 165.623 120.872 164.478 121.401C163.333 121.929 162.076 122.174 160.815 122.115C149.763 121.612 138.007 121.33 125.794 121.33C62.6993 121.33 11.5493 128.639 11.5493 137.661C11.5493 146.682 62.6993 154 125.794 154C188.889 154 239.999 146.69 239.999 137.684C239.999 134.183 232.349 130.956 219.331 128.302Z",
    fill: "#C9D3DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M100.453 132.917C100.453 132.917 101.621 136.864 105.087 137.33C108.553 137.795 109.279 141.277 106.098 141.988C102.916 142.698 95.0452 138.238 95.0452 138.238L95.5426 133.224L100.453 132.917Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M32.9764 132.245C32.9764 132.245 28.9659 133.114 28.2396 136.532C27.5133 139.951 23.9922 140.408 23.5028 137.18C23.0133 133.951 28.0896 126.458 28.0896 126.458L33.0475 127.351L32.9764 132.245Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.5134 73.3034C33.5134 73.3034 29.8186 90.5455 43.1213 97.935C56.4239 105.324 98.3844 92.0218 91.9029 133.903H101.266C101.266 133.903 113.369 99.1665 81.9713 86.8192L72.4423 76.0113L33.5134 73.3034Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M162.69 60.8579L159.505 57.8144L139.586 78.6587L142.771 81.7022L162.69 60.8579Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.08,
    d: "M162.69 60.8579L159.505 57.8144L139.586 78.6587L142.771 81.7022L162.69 60.8579Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M161.139 59.3655L157.954 56.322L138.034 77.1663L141.219 80.2098L161.139 59.3655Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M169.802 63.2011C174.923 57.8423 176.177 50.7289 172.602 47.3129C169.027 43.8969 161.978 45.4719 156.857 50.8307C151.736 56.1895 150.483 63.3029 154.057 66.7189C157.632 70.1349 164.681 68.56 169.802 63.2011Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.08,
    d: "M169.802 63.2011C174.923 57.8423 176.177 50.7289 172.602 47.3129C169.027 43.8969 161.978 45.4719 156.857 50.8307C151.736 56.1895 150.483 63.3029 154.057 66.7189C157.632 70.1349 164.681 68.56 169.802 63.2011Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M168.247 61.721C173.368 56.3622 174.622 49.2488 171.047 45.8328C167.472 42.4168 160.423 43.9918 155.302 49.3506C150.181 54.7094 148.928 61.8228 152.502 65.2388C156.077 68.6548 163.126 67.0798 168.247 61.721Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.57,
    d: "M166.05 59.6209C169.432 56.081 170.261 51.3822 167.9 49.126C165.539 46.8697 160.882 47.9104 157.499 51.4504C154.117 54.9903 153.288 59.6891 155.649 61.9453C158.01 64.2016 162.667 63.1609 166.05 59.6209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M135.197 17.7716C135.197 17.7716 131.636 22.9427 128.178 25.4848C127.843 25.7291 127.463 25.9049 127.059 26.0022C126.656 26.0995 126.238 26.1164 125.828 26.0519C125.418 25.9874 125.025 25.8427 124.671 25.6262C124.317 25.4097 124.009 25.1256 123.765 24.7901C122.51 23.0295 121.326 20.2822 122.897 17.2822L124.934 11.8585C125.462 10.8218 126.297 9.97397 127.326 9.4312C128.355 8.88843 129.527 8.67734 130.681 8.82689C134.999 9.07953 137.518 14.7322 135.197 17.7716Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M126.181 12.9716L110.115 19.4453L112.089 30.8768L123.67 21.4268L126.181 12.9716Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M133.831 16.9822C132.287 15.8054 130.883 14.4543 129.647 12.9559C129.535 13.9708 129.13 14.931 128.481 15.719C127.832 16.5071 126.967 17.0887 125.992 17.3927C125.053 17.7021 124.035 17.6751 123.113 17.3165C122.191 16.9578 121.423 16.2898 120.939 15.4269L126.15 9.26903C126.862 8.35777 127.808 7.65639 128.886 7.23938C129.965 6.82237 131.136 6.7053 132.276 6.90061C133.261 7.07023 134.234 7.30228 135.189 7.59535C137.558 8.38482 139.208 11.7164 141.813 11.8269C142.075 11.8397 142.329 11.9203 142.551 12.0608C142.772 12.2012 142.954 12.3968 143.077 12.6283C143.2 12.8598 143.261 13.1194 143.254 13.3816C143.247 13.6438 143.172 13.8997 143.037 14.1243C141.758 16.248 138.963 18.948 135.545 17.8664C134.929 17.6679 134.35 17.3692 133.831 16.9822V16.9822Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M126.631 17.6771C126.631 17.6771 128.131 15.7823 126.631 14.7639C125.131 13.7455 122.928 16.4771 124.626 18.3007L126.631 17.6771Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M132.789 20.914L132.6 23.8903C132.584 24.0569 132.527 24.2169 132.434 24.356C132.341 24.495 132.215 24.6088 132.067 24.6871C131.919 24.7654 131.754 24.8057 131.586 24.8044C131.419 24.8031 131.255 24.7603 131.108 24.6798L128.968 23.4956L132.789 20.914Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    opacity: 0.31,
    d: "M122.369 22.4767C122.369 22.4767 122.85 18.8846 124.145 17.5188C124.145 17.5188 118.295 19.4925 118.161 25.9267L122.369 22.4767Z",
    fill: "#CE8172"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    opacity: 0.08,
    d: "M16.3103 66.0245C16.3103 66.0245 16.0576 28.785 60.7892 20.914L34.5076 67.4219H16.3497L16.3103 66.0245Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M114.221 34.8324L112.894 27.1192C112.376 23.9736 111.067 21.011 109.091 18.5091C107.115 16.0071 104.537 14.0475 101.597 12.814C99.0381 11.791 96.3626 11.0883 93.6313 10.7219C90.126 10.2324 85.2155 10.7219 79.7207 12.1666C56.0523 18.3798 38.6839 38.4324 35.0918 62.6061L33.5128 73.3035L72.4418 76.0114C72.4418 76.0114 70.4681 64.9587 84.2839 64.9587C98.0997 64.9587 115.594 65.1008 114.221 34.8324Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    opacity: 0.08,
    d: "M76.0733 22.8718C76.0733 22.8718 57.1812 26.1955 36.4181 56.1165L33.5128 73.3034L63.0549 75.4981L76.0733 22.8718Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M97.7373 36.6324C101.424 24.3324 87.1267 14.385 76.9346 22.2008C68.4083 28.7297 58.7767 40.485 58.3978 60.3245C57.7425 96.1271 92.0373 89.7245 138.45 76.0113L136.974 65.5824C136.974 65.5824 81.3952 76.0903 88.9425 58.0271C92.1004 50.4719 95.7794 43.1771 97.7373 36.6324Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    opacity: 0.2,
    d: "M97.7373 36.6324C101.424 24.3324 87.1267 14.385 76.9346 22.2008C68.4083 28.7297 58.7767 40.485 58.3978 60.3245C57.7425 96.1271 92.0373 89.7245 138.45 76.0113L136.974 65.5824C136.974 65.5824 81.3952 76.0903 88.9425 58.0271C92.1004 50.4719 95.7794 43.1771 97.7373 36.6324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M78.2293 86.9061C78.2293 86.9061 79.3741 126.498 33.0478 133.903L31.2556 125.511C31.2556 125.511 68.3609 116.314 44.3925 91.6745L78.2293 86.9061Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    opacity: 0.4,
    d: "M151.2 140.148C153.982 140.148 156.237 139.314 156.237 138.285C156.237 137.256 153.982 136.422 151.2 136.422C148.418 136.422 146.163 137.256 146.163 138.285C146.163 139.314 148.418 140.148 151.2 140.148Z",
    fill: "#668099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    opacity: 0.4,
    d: "M170.462 135.325C173.244 135.325 175.499 134.49 175.499 133.461C175.499 132.432 173.244 131.598 170.462 131.598C167.681 131.598 165.425 132.432 165.425 133.461C165.425 134.49 167.681 135.325 170.462 135.325Z",
    fill: "#668099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    opacity: 0.4,
    d: "M189.86 139.051C192.642 139.051 194.897 138.216 194.897 137.187C194.897 136.158 192.642 135.324 189.86 135.324C187.078 135.324 184.823 136.158 184.823 137.187C184.823 138.216 187.078 139.051 189.86 139.051Z",
    fill: "#668099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    opacity: 0.4,
    d: "M219.561 140.922C222.342 140.922 224.597 140.088 224.597 139.059C224.597 138.03 222.342 137.195 219.561 137.195C216.779 137.195 214.524 138.03 214.524 139.059C214.524 140.088 216.779 140.922 219.561 140.922Z",
    fill: "#668099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    opacity: 0.4,
    d: "M132.103 134.906C134.946 134.906 137.251 134.05 137.251 132.995C137.251 131.94 134.946 131.085 132.103 131.085C129.261 131.085 126.956 131.94 126.956 132.995C126.956 134.05 129.261 134.906 132.103 134.906Z",
    fill: "#668099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M137.257 67.5874C137.257 67.5874 150.031 66.2374 151.152 71.2269C152.273 76.2163 149.826 78.8611 138.331 75.1742L137.257 67.5874Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M10.0019 67.4218C10.0019 67.4218 11.8414 74.8744 19.2072 73.3033C26.5729 71.7323 21.315 62.5902 10.0019 67.4218Z",
    fill: "#F4A28C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 239.999,
    height: 154,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFile);
export default __webpack_public_path__ + "static/media/no-file.19e4d7f177f0069d1b4502d6fce3e8ad.svg";
export { ForwardRef as ReactComponent };